import { setEnv } from "./constants";
import * as XLSX from 'xlsx'
import moment from 'moment';
import { html } from 'lit';
import parse from 'html-react-parser';
import { getEnvironment } from "./amplitude";
// import { CookieService } from "../services/cookie.service";
import {CookieService, creativeMap } from "../../shared";
export const CreativeAndTaxonomyUtils = {

  setCreativeTableData : (data,omniProfile) => {
      let taxonomyMap = {};
      for (let i = 0; i < data.length; i++) {
  
          // check the login/update time and set highlight true for creatives
          let highlight = false;
          const loginTime = new Date(new Date(CookieService.getCookie("LoginTime")).toUTCString());
          const createTime = new Date(data[i]?.created_at + 'Z');
          const updateTime = new Date(data[i]?.updated_at + 'Z');
          if ((loginTime < createTime && data[i]?.created_by === omniProfile?.email) || (loginTime < updateTime && data[i]?.updated_by === omniProfile?.email)) {
            highlight = true;
          }
  
          let taxonomyObj = {
            rowIndex: i,
            _id: data[i].creative_id,
            taxonomyName: data[i].creative_type,
            taxonomyValue: data[i].creative_name,
            taxonomySchema: data[i].taxonomy_schema,
            taxonomyId: data[i].taxonomy_schema_id,
            supplierCode: data[i].supplier_code,
            dimensions: data[i].dimensions,
            dimensions_position: data[i].dimensions_position,
            site: data[i].supplier,
            checked: false,
            isOverride: data[i].is_override,
            isCreative: true,
            highlight: highlight
          };
          taxonomyObj = { ...data[i], ...taxonomyObj };
          let creativeType = CreativeAndTaxonomyUtils.mapCreativeTypeToTaxonomy(data[i].creative_type);
          // Grouping based on taxonomy
          if (!taxonomyMap[creativeType]) {
            taxonomyMap[creativeType] = [];
            taxonomyMap[creativeType].push(taxonomyObj);
          } else {
            taxonomyMap[creativeType].push(taxonomyObj);
          }
      }
      return taxonomyMap;
    },

    /**
     * This function maps creative types to taxonomy categories.
     * @param {string} creativeType - The type of creative to map.
     * @returns {string|null} - The mapped taxonomy category or null if not found.
     */
    mapCreativeTypeToTaxonomy : (creativeType) => {
      for(let key in creativeMap) {
        if(creativeMap[key].includes(creativeType)) {
          return creativeMap[key][0];
        }
      }
      return null;
    },

    /**
   * Creates a table structure for the taxonomies.
   * @function createTableStructure
   * @param {object} taxonomyMap - The map of taxonomies.
   * @returns {void}
   * This function iterates through the taxonomyMap and creates a list of taxonomies with unique keys and element IDs.
   * It also sets the state with the created taxonomy list and calls afterTableOperations.
   * If the created taxonomy list is empty, it adds a default object to the list.
  */ 
  createTableStructure : (taxonomyMap) => {
    let createdTaxonomyList = [];
    let currentElement = 0;
    for (const key in taxonomyMap) {
      if (taxonomyMap.hasOwnProperty(key)) {
        for (let j = 0; j < taxonomyMap[key].length; j++) {
          taxonomyMap[key][j]._uniqueKey = j;
          taxonomyMap[key][j].elementId = currentElement;
        }
        let taxonomyListObj = {
          id: currentElement,
          taxonomy_id: key,
          taxonomyTableData: taxonomyMap[key],
        };
        createdTaxonomyList.push(taxonomyListObj);
      }
      currentElement++;
    }
    // Sort the createdTaxonomyList based on taxonomy_id
    if (createdTaxonomyList.length) {
      // Sort the createdTaxonomyList based on taxonomy_id to retain table position
      createdTaxonomyList.sort((a, b) => {
        if (a.taxonomy_id < b.taxonomy_id) return -1;
        if (a.taxonomy_id > b.taxonomy_id) return 1;
        return 0;
      });
      // Sort the data based on created_at , newly created will come at last
      for(let i=0;i<createdTaxonomyList.length;i++) {
        createdTaxonomyList[i].taxonomyTableData.sort((a, b) => {
          if (a.created_at < b.created_at) return -1;
          if (a.created_at > b.created_at) return 1;
          return 0;
        });
      }
    } else {
      createdTaxonomyList.push({
        id: 0,
        taxonomyTableData: [],
      });
    }

    return createdTaxonomyList;
  },

};
